import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Header, Body, Typography } from "../styled";
import { format } from "date-fns";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const Social: FC = () => {
    return (
        <Box mt={1}>
            <Header>
                <Box display={'flex'}>
                    <Typography mb={1} ml={25}>Наименование льготы</Typography>
                    <Typography mb={1} ml={36}>№ документа</Typography>
                    <Typography mb={1} ml={18}>Дата</Typography>
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>
                <Box display='flex'>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{width: "600px", mr: 1, mb: 1 }}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "200px", mr: 1 }}
                    />
                </Box>

            </Header>
            <Body>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={12}>Льгота</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, ml: 8.9, mr: 1}}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={14.4}>№ документа</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "300px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={5}>Дата выдачи документа</Typography>
                    <TextField
                        value={format(1683886255004, "dd.MM.yyyy")}
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, mr: 1}}
                    />
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                    <Typography mr={13.9}>Основание</Typography>
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "110px", mb: 1, ml: 2.8, mr: 1}}
                    />
                    <TextField
                        variant="outlined"
                        size="small"
                        sx={{ width: "600px", mb: 1, mr: 1}}
                    />
                </Box>

            </Body>
        </Box>
    );
};

export default Social;

